<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.accountingReport') }}</strong>
          </CCardHeader>
          <br>
          <CRow>


            <CCol col="3"> <treeselect
                    v-model="selected_moein"
                    appendToBody
                    :normalizer="normalizer_accounting"
                    @select="select_moein"

                    :options="moein_list"
                    :placeholder="$t('components.moenAccount')"
            /></CCol>
            <CCol col="3"><treeselect
                    v-model="selected_tafsili"
                    appendToBody
                    :options="tafsili_list"
                    :placeholder="$t('tafsili')"
                    :normalizer="normalizer_accounting_tafzili"
            /></CCol>
            <CCol col="3">
              <CButton color="dark"
              size="sm">
                <CIcon size="sm" name="cil-zoom"/>
              </CButton>

            </CCol>
          </CRow>
          <CCardBody>
                <CDataTable
                    :items="items_customer"
                    :fields="fields"

                    :items-per-page="20"
                    hover
                    border
                    pagination
                    striped
                >
                  <template #row_id="{item,index}">

                    <td>
                      <p >{{ index+1 }}</p>

                    </td>

                  </template>

                  <template #amount="{item}">
                    <td>
                      <p >{{ item.amount }} {{ VUE_APP_Currency }}</p>
                    </td>
                  </template>
                  <template #amountNegetive="{item}">
                    <td>
                      <p >{{ item.amountNegetive }} {{ VUE_APP_Currency }}</p>
                    </td>
                  </template>
                  <template #accBalance="{item}">
                    <td>
                      <p >{{ item.accBalance }} {{ VUE_APP_Currency }}</p>
                    </td>
                  </template>
                  <template #accBalanceNegetive="{item}">
                    <td>
                      <p >{{ item.accBalanceNegetive }} {{ VUE_APP_Currency }}</p>
                    </td>
                  </template>

                  <template #kardexAccTypeTitle="{item}">
                    <td>
                      <p >{{ item.kardexAccTypeTitle }}</p>
                    </td>
                  </template>

                  <template #masterId="{item}">
                    <td>
                      <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                        {{ item.masterId }}
                        <CIcon name="cil-speedometer"/>
                      </a>

                    </td>

                  </template>

                  <template #summary="{item}">
                    <td>
                      <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                    </td>

                  </template>

                  <template #operation="{item}">
                    <td >
                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="goEditPerson(item)"
                      >
                        <CIcon name="cil-pencil"/>
                      </CButton>
                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.documents')"
                               @click="goToDocuments(item)"
                      >
                        <CIcon name="cil-list-rich"/>
                      </CButton>
                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.commission')"
                               @click="goToPorsant(item)"
                      >
                        <CIcon name="cil-dollar"/>
                      </CButton>
                    </td>
                  </template>


                </CDataTable>

          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
var items_data = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      VUE_APP_Currency:localStorage.getItem('currency'),
      items_customer: items_data.map((item, row_id) => {
        if (item.isCustomer) {
          return {...item, row_id}

        }
      }),
      fields: [//amount amountNegetive accBalance accBalanceNegetive
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'masterId', label: this.$t('tables.factorId'), _style: 'width:10%'},
        {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
        {key: 'accBalanceNegetive', label: this.$t('tables.debtorBalance'), _style: 'width:10%'},
        {key: 'accBalance', label: this.$t('tables.creditBalance'), _style: 'width:10%'},
        {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
        {key: 'kardexAccTypeTitle', label: this.$t('tables.type'), _style: 'width:10%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],
      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode + " " + node.accountName,
        }
      },
      normalizer_accounting_tafzili(node) {
        return {
          id: node.recId,
          label: node.title,
        }
      },
      templates_items: [],
      accounting_list: [],
      moein_list: [],
      tafsili_list: [],
      selected_moein:null,
      selected_tafsili:null,
      collapseDuration: 0,
      person_name:'',
      status_form: 0
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_lists_groups();
    this.get_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_tafsili': function () {
      // this.get_lists();
    }
  },
  methods: {
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    select_moein( node) {
      var self = this;

      const formData = new FormData();
      var url = "GetAccountTafsiliList";
      formData.append("id", node.id);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

                var content_data = response.data;

                if (content_data.statusCode == 0) {

                  // item.tafzili_list = response.data.data;
                  self.tafsili_list=response.data.data
                } else {
                  self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                }

              }
      ).catch(function (error) {
        console.log(error);
      });

    },
    get_lists_groups() {

      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      axios.post(url, formData, {}).then(function (response) {

                var content_data = response.data;

                if (content_data.statusCode == 0) {

                  self.accounting_list = response.data.data
                  response.data.data.forEach((val) => {
                    if (val.parentId == 0) {

                      self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                        self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                          self.moein_list.push(val3)

                        });

                      });

                    }

                  });
                } else {
                  self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                }

              }
      )
              .catch(function (error) {
                console.log(error);
              });

    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetPersonAccountsByPersonId_New";

      formData.append('id', "1532");

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.personAccountItems;
          self.items_customer.forEach(function (val,index) {
            if(index==0) {
              val.reminingBefore = 0;
              if(val.natureId==0 && self.items_customer[index+1]!=null){
                val.natureId = self.items_customer[index+1].natureId;
              }
              // val.accBalance = val.accBalance
            }else{
              val.reminingBefore = self.items_customer[index-1].accBalance;

              if(val.natureId==2){
                val.accBalance = parseFloat(val.reminingBefore) +  parseFloat(val.amount);
                // val.accBalanceFinal =val.accBalance
                if(val.amount>0){
                  val.amountNegetive=Math.abs(val.amount);
                  val.amount=0;

                }else{
                  val.amount=Math.abs(val.amount);
                  val.amountNegetive=0;
                }
              }else{

                val.accBalance = parseFloat(val.reminingBefore)   + parseFloat(val.amount);
                if(val.amount<0){
                  val.amountNegetive=0;
                  val.amount=Math.abs(val.amount);

                }else{
                  val.amountNegetive=Math.abs(val.amount);
                  val.amount=0;

                }
              }
            }

          })


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
